'use strict'

export const MaterialSpinnerOptions = {
  width: 4,
  color: 'white',
  size: 160,
  delay: false
}

export default class MaterialSpinner {
  constructor(el, options = {}) {
    this.REQUEST = false
    this.ANIMATION_CHECK = false
    this.options = options
    this.options = Object.assign({}, MaterialSpinnerOptions, options)

    this.canvas = document.getElementById(el)
    this.ctx = this.canvas.getContext('2d')

    this.i = 0
    this.d = 0

    this.init()
  }

  init() {
    if (this.options.delay) {
      setTimeout(() => {
        this.animationLoop()
      }, this.options.delay)
    } else {
      this.animationLoop()
    }
  }

  render() {
    this.i += 0.01
    this.ctx.translate((this.options.size / 2), (this.options.size / 2))
    this.ctx.rotate(0.1)
    this.ctx.translate(-(this.options.size / 2), -(this.options.size / 2))
    this.ctx.clearRect(0, 0, this.options.size, this.options.size)
    this.ctx.beginPath()

    let t = this.i - Math.floor(this.i)
    let t2 = this.i - Math.floor(this.i)
    if (Math.floor(this.i) % 2 === 1) {
      t = 0
    } else {
      t2 = 1
    }
    if (Math.floor(this.i) % 2 === 0 && Math.floor(this.i) > this.d * 2) {
      this.d++
    }

    const y = (Math.pow(t, 1)) / (Math.pow(t, 1) + Math.pow((1 - t), 1))
    const y2 = (Math.pow(t2, 1)) / (Math.pow(t2, 1) + Math.pow((1 - t2), 1))
    this.ctx.arc((this.options.size / 2), (this.options.size / 2), 50,
      (y * 5 + Math.floor(this.i) * 5 + this.d * 1.28).toFixed(1),
      (y2 * 5 + 0.15 + Math.floor(this.i) * 5 + this.d * 1.28).toFixed(1)
    )
    this.ctx.lineWidth = this.options.width
    this.ctx.lineCap = 'round'
    this.ctx.strokeStyle = this.options.color
    this.ctx.stroke()
    this.ctx.closePath()

    this.ctx.translate((this.options.size / 2), (this.options.size / 2))
    this.ctx.rotate(0.1)
    this.ctx.translate(-(this.options.size / 2), -(this.options.size / 2))
    this.ctx.beginPath()
    this.ctx.arc(
      (this.options.size / 2),
      (this.options.size / 2),
      30,
      -(y2 * 5 + Math.floor(this.i) * 5 + this.d * 1.28).toFixed(2),
      -(y * 5 + Math.floor(this.i) * 5 + this.d * 1.28).toFixed(2)
    )
    this.ctx.lineWidth = this.options.width
    this.ctx.lineCap = 'round'
    this.ctx.strokeStyle = this.options.color
    this.ctx.stroke()
  }

  /**
   * アニメーションループ開始
   */
  animationLoop() {
    if (!this.ANIMATION_CHECK) {
      this.render()
      this.REQUEST = window.requestAnimationFrame(this.animationLoop.bind(this))
      this.animationFrameCount++
    }
  }
  /**
   * アニメーション停止
   */
  animationStop() {
    this.ANIMATION_CHECK = true
    if (this.REQUEST) window.cancelAnimationFrame(this.REQUEST)
  }

  /**
   * アニメーション再開
   */
  animationStart() {
    this.ANIMATION_CHECK = false
    if (this.options.delay) {
      setTimeout(() => {
        this.animationLoop()
      }, this.options.delay)
    } else {
      this.animationLoop()
    }
  }

  /**
   * アニメーション再開
   */
  destroy() {
    this.animationStop()
  }
}
